
import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  CLEAR_FORGOT_PASSWORD_STATE,
} from '../actions/types';

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        successMessage: null,
        errorMessage: null,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: payload,
        errorMessage: null,
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        successMessage: null,
        errorMessage: payload,
      };
    case CLEAR_FORGOT_PASSWORD_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}